<div class="uv-modal box position-center padding-sm">
    <ng-content></ng-content>
</div>
